import useFetchMorePagination from '@@partner:helpers/hooks/useFetchMorePagination'
import { usePartner } from '@@partner:helpers/hooks/auth'
import { GQL_ID } from '@@partner:types:graphql'
import { renderLazyPickerMenu } from '@components/common/pickers'
import React, { useCallback } from 'react'
import {  SelectPicker } from 'rsuite'
import { AllProductGroupsQuery, useFetchAllProductGroups } from '@@partner:graphql/query/productGroup/allProductGroups.gql'
import { blockTypes } from './EditorItem'
import CategoriesFilter from '@components/catalog/product/grid/CategoriesFilter'
import { MainPageBlockForm } from '../form/MainPageConfigFormState'
import ProductsFilterBlock from './ProductsFilterBlock'
import EntityLink from './EntityLink'


type BannerBlockProps = {
  block: MainPageBlockForm
  onChange: (block: MainPageBlockForm) => void
}

export default function ProductsBlock ({
  block,
  onChange
}: BannerBlockProps) {
  const { brandSlug } = usePartner()
  const [ nameFilter, setNameFilter ] = React.useState<string>('')

  const subtype = block.subtype

  const makeBasicVariables = (skip: boolean) => ({
    filter: {
      fields: [ 'name' ],
      op: nameFilter.length > 0 ? 'starts_with' : 'unwrap',
      value: [ nameFilter ]
    },
    pager: { 
      limit: 20
    },
    sort: {
      fieldName: 'created_at',
      direction: 0
    },
    skip
  })

  const { data, loading, error, fetchMore } = useFetchAllProductGroups(makeBasicVariables(subtype !== 'group'))

  const updaterFunction = useCallback((cached: AllProductGroupsQuery, fetched: AllProductGroupsQuery) => {
    const prev = cached?.allProductGroups?.edges ?? []
    const curr = fetched?.allProductGroups?.edges ?? []

    return {
      hasMore: curr.length > 0,
      result: {
        allBanners: {
          ...fetched.allProductGroups,
          edges: [ ...prev, ...curr ]
        }
      }
    }
  }, [])

  const { hasMore, fetchNextPage } = useFetchMorePagination({
    loading,
    page: data?.allProductGroups.pageInfo.page ?? 1,
    pageVariable: 'pager',
    usePager: true,
    fetchMore,
    updaterFunction,
  })

  const productGroups = data?.allProductGroups.edges.map((banner) => ({
    label: banner.name,
    value: banner.id,
  })) ?? []

  const onItemsRendered = (props: any) => {
    if (props.visibleStopIndex >= productGroups.length - 1 && hasMore) {
      fetchNextPage()
    }
  }

  return (
    <div>
      <h4>Выберите источник товаров:</h4>
      <SelectPicker
        data={blockTypes.find(bt => bt.type === 'products')?.subtypes ?? []}
        value={block.subtype}
        onSelect={(value) => {
          if (onChange && value) {
            onChange({
              ...block,
              subtype: value,
            })
          }
        }}
        placeholder="Выберите источник товаров"
        style={{ marginBottom: 16 }}
      />
      { block.subtype === 'group' ? (
        <div>
          <h4>Выберите группу:</h4>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <SelectPicker
              data={productGroups}
              value={block.payload?.id}
              loading={loading && !data}
              onSelect={(value) => {
                if (onChange && value) {
                  onChange({
                    ...block,
                    payload: {
                      id: value,
                    }
                  })
                }
              }}
              onSearch={setNameFilter}
              renderMenu={renderLazyPickerMenu(loading, data)}
              placeholder="Выберите группу"
              listProps={{
                onItemsRendered
              }}
              style={{ flex: 1 }}
            />
            <EntityLink
              entityId={block.payload?.id}
              entityType="productGroup"
              brandSlug={brandSlug}
              tooltip="Перейти к группе товаров"
            />
          </div>
        </div>
      ) : block.subtype === 'category' ? (
        <div>
          <h4>Выберите категорию:</h4>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ flex: 1 }}>
              <CategoriesFilter
                value={[ block.payload?.id ]}
                multiple={false}
                onChange={(value: GQL_ID[]) => {
                  if (onChange) {
                    onChange({
                      ...block,
                      payload: {
                        id: value[0]
                      }
                    })
                  }
                }}
              />
            </div>
            <EntityLink
              entityId={block.payload?.id}
              entityType="category"
              brandSlug={brandSlug}
              tooltip="Перейти к категории"
            />
          </div>
        </div>
      ) : block.subtype === 'filter' ? (
        <ProductsFilterBlock block={block} onChange={onChange} />
      ) : (
        <div></div>
      )}
    </div>
  )
}